import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import styles from './styles.module.css';

function HeroSection(){
    return (
        <section className={styles.hero}>
                <div className={styles.heroGlow} />
                <div className={styles.heroContent}>
                    <span className={styles.heroBadge}>✨ Sem cartão de crédito • Setup em 2 minutos</span>
                    <h1 className={styles.heroTitle}>
                        Orçamentos<br />
                        <span className={styles.heroAccent}>sem complicação</span>
                    </h1>
                    <p className={styles.heroDesc}>
                        O Orçamento Digital é a solução completa para freelancers e pequenas empresas criarem
                        seus orçamentos de forma rápida, segura e profissional.
                    </p>
                    <div className={styles.heroCta}>
                        <Link to="/register" className={styles.btnPrimary}>
                            Começar Grátis <ArrowRight size={18} />
                        </Link>
                        <Link to="/planos" className={styles.btnOutline}>
                            Ver Planos
                        </Link>
                    </div>
                </div>
            </section>
    );
}

export default HeroSection;